import { isFlagOn } from "../utils";
import useAppSelector from "../../../hooks/useAppSelector";
export default function useIsFlagOn(flag) {
    return useAppSelector(function (state) { return isFlagOn(state.featureFlags.flags[flag]); });
}
